<template>
  <v-data-table :headers="headers" :items="evaluaciones" :items-per-page="10" class="elevation-1">
    <template v-slot:[`item.id`]="{ item }">
      {{ item.idProductividad || item.idRespetoPrincipios }}
    </template>

    <template v-slot:[`item.fechaAplicacion`]="{ item }">
      {{ getFormattedDate(item) }}
    </template>

    <template v-slot:[`item.evaluado`]="{ item }">
      {{
        `${item.Evaluado[0].Nombre} ${item.Evaluado[0].segundoNombre} ${item.Evaluado[0].apaterno} ${item.Evaluado[0].amaterno}`
      }}
    </template>

    <template v-slot:[`item.estatus`]="{ item }">
      <v-chip :color="getStatusColor(item.estatus)" text-color="white" small>
        {{ item.estatus }}
      </v-chip>
    </template>

    <template v-slot:[`item.opciones`]="{ item }">
      <v-btn
        icon
        small
        color="warning"
        @click="$emit('edit-evaluation', item)"
        title="Editar evaluación"
        :loading="isLoading(item)"
        :disabled="isLoading(item) || item.estatus === 'Finalizada'"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    evaluaciones: {
      type: Array,
      required: true,
    },
    selectedTab: {
      type: String,
      required: true,
    },
    loadingEvaluationId: {
      type: [String, Number],
      default: null,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id',
        },
        {
          text: 'Fecha de aplicación',
          align: 'start',
          value: 'fechaAplicacion',
        },
        {
          text: 'Evaluado',
          align: 'start',
          value: 'evaluado',
        },
        {
          text: 'CUIP',
          value: 'Evaluado[0].CUIP',
        },
        {
          text: 'Estatus de evaluación',
          value: 'estatusEvaluacion',
        },
        {
          text: 'Opciones',
          value: 'opciones',
          sortable: false,
          align: 'center',
        },
      ],
    }
  },

  methods: {
    isLoading(item) {
      if (!this.loadingEvaluationId) return false
      return this.getItemId(item) === this.loadingEvaluationId
    },

    getItemId(item) {
      switch (this.selectedTab) {
        case 'Productividad':
          return item.idProductividad || item.id
        case 'Respeto a los principios':
          return item.idRespetoPrincipios || item.id
        case 'Evaluacion anual':
          return item.idEvaluacionAnual || item.id
        default:
          return item.id || item.idProductividad || item.idRespetoPrincipios || item.idEvaluacionAnual
      }
    },

    getStatusColor(status) {
      switch (status) {
        case 'Pendiente':
          return 'orange'
        case 'En proceso':
          return 'blue'
        case 'Finalizada':
          return 'green'
        case 'Cancelada':
          return 'red'
        default:
          return 'grey'
      }
    },

    getFormattedDate(item) {
      const dateValue = item?.fecha

      if (!dateValue) return '-'

      let date
      if (typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        const [year, month, day] = dateValue.split('-').map(Number)
        date = new Date(year, month - 1, day)
      } else {
        date = new Date(dateValue)
      }
      if (Number.isNaN(date.getTime())) return '-'

      const options = { year: 'numeric', month: 'long', day: 'numeric' }
      return date.toLocaleDateString('es-MX', options)
    },
  },
}
</script>
